module.exports = __webpack_public_path__ + "img/2s.c2170a95.png";